<template>
  <section class='content'>
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">{{'brands' | translate}}</h3>
            <div class="box-tools pull-right">
              <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button>
              <button type="button" class="btn btn-box-tool" data-widget="remove"><i class="fa fa-times"></i></button>
            </div>
          </div>
          <div class="box-controls">
            <div class="row">
              <div class="col-xs-12">
                <my-pagination :lang="$store.getters.language" :total="pagination.total" :per-page="pagination.per_page" :pagination="pagination"></my-pagination>
                <div class="collapse in" id="coll1">
                  <div class="row">
                    <div class="col-md-3 col-sm-6">
                      <div class="input-group">
                        <input type="text" name="search" v-model="brandName" class="form-control" :placeholder="'brand' | translate" @keyup.13.prevent="paginate('','')" @blur="paginate('','')">
                        <div class="input-group-btn">
                          <button type="submit" name="submit" class="btn"><i class="fa fa-search"></i></button>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-2 col-sm-6">
                      <div class="input-group">
                        <div class="input-group-addon">{{'show' | translate | capitalize}}:</div>
                        <select id="count-select" class="form-control" v-model="count" @change.prevent="paginate('count','')">
                          <option class="normal" value="10">10</option>
                          <option class="normal" value="25">25</option>
                          <option class="normal" value="50">50</option>
                          <option class="normal" value="100">100</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="box-body">
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>{{'brand_img' | translate}}</th>
                    <th>{{'brand' | translate}}</th>
                    <th>{{'sales_channels' | translate}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="brand in pagination.data">
                    <td>
                      <img class="img-responsive" :src="brand.logo_url">
                    </td>
                    <td>
                      {{brand.name}}
                    </td>
                    <td>
                      <template v-for="(val, key) in brand.channels">
                        <template v-if="key !== 'tamaris'">
                          <span :class="[val === false ? 'text-danger' : 'text-success']">
                          <i class="mr-5" :class="[val === false ? 'fa fa-exclamation-triangle' : 'fa fa-sign-in']"></i>
                          {{key | capitalize}} <br />
                        </span>
                        </template>
                      </template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: "Brands",
    data () {
      return {
        count: 25,
        brandName: '',
        pagination: {
          total: 0,
          per_page: 25,
          current_page: 1,
          total_pages: 0,
          data: []
        },
        alerts: [],
      }
    },
    methods: {
      paginate (type, value) {
        this.loading = true
        let url = '?preflight=kek'
        if (type === 'page') {
          url += '&page='
          if (value === 'previous') {
            url += (this.pagination.current_page - 1)
          }
          if (value === 'next') {
            url += this.pagination.current_page >= this.pagination.last_page ? this.pagination.last_page : (this.pagination.current_page + 1)
          } else if (value !== 'next' && value !== 'previous') {
            url += value
          }
        }
        url += `&count=${this.count}`
        url += `&name=${this.brandName}`
        API.get(`monitoring/brands/marketplaces${url}`)
          .then(response => {
            this.pagination = response.data
            this.loading = false
          })
          .catch(error => {
            this.$store.dispatch('checkError', error)
          })
      }
    },
    mounted () {
      API.get('monitoring/brands/marketplaces', {})
        .then(response => {
          this.pagination = response.data
      })
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/Monitoring/Brands.vue